'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../../styleInject.js');

var css_248z = ".DetailsCard-module_container__3D6yT{align-items:center;flex-direction:row;text-align:left;width:100%}.DetailsCard-module_vertical__hpHZK{flex-direction:column;text-align:center}.DetailsCard-module_attributesContainer__DgVT8{align-items:flex-start;flex-direction:column}@container (max-width: 300px){.DetailsCard-module_container__3D6yT{flex-direction:column}}";
var styles = {"container":"DetailsCard-module_container__3D6yT","vertical":"DetailsCard-module_vertical__hpHZK","attributesContainer":"DetailsCard-module_attributesContainer__DgVT8"};
styleInject["default"](css_248z, 'bda3269a-d036-4f91-9adf-4a43f3b43abf');

exports["default"] = styles;
